import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  align: "left",
  valign: "top",
  style: {"color":"#666666","font-size":"13px","padding":"30px 25px","line-height":"1.8"},
  width: "400"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"font-size":"18px","font-weight":"600"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  class: "arial",
  style: {"font-size":"24px","font-weight":"700"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { width: "400" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { width: "100" }, "場所", -1)
const _hoisted_13 = {
  width: "300",
  style: {"padding":"0px 20px"}
}
const _hoisted_14 = { style: {"font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailPreviewPartsOnlineTable = _resolveComponent("MailPreviewPartsOnlineTable")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", null, [
        (!_ctx.hideTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, " ■ " + _toDisplayString(_ctx.Util.isPresent(_ctx.rcm.appeal_content) && _ctx.Util.isPresent(_ctx.rcm.appeal_content.title)
                                ? _ctx.rcm.appeal_content.title
                                : _ctx.rcm.appo.name), 1),
              _hoisted_4,
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.rcm.demoFixFormat(null)) + "（" + _toDisplayString(_ctx.rcm.appo.duration) + "分） ", 1),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("table", _hoisted_9, [
          (_ctx.Util.isOnline(_ctx.rcm.appo.location_name))
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createVNode(_component_MailPreviewPartsOnlineTable)
              ]))
            : (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.rcm.appo.location_name), 1)
                ])
              ]))
        ])
      ])
    ])
  ]))
}